import { IconDefinition } from "./types";

const leftArrow: IconDefinition = {
  iconName: "left-arrow",
  width: 16,
  height: 16,
  svgPathData: "M7 3L2 8l5 5m6.5-5h-10",
  iconType: "stroke",
};

export { leftArrow };
